/**
 * EventDescriptionView — the event introduction, rendered, on the event detail page.
 *
 * The stored HTML is set as innerHTML only after DOMPurify (utils/eventDescription
 * `sanitizeDescription`), to the same allowlist the service keeps. The service has already
 * sanitized it on write; this is the second, independent layer.
 *
 * Images load from the presigned URLs the service put on them when the event was read, which last
 * about an hour — a page left open longer shows them broken until it is reloaded.
 */
import { useMemo } from 'react';
import { sanitizeDescription } from '../../utils/eventDescription';
import './EventDescriptionView.css';

export default function EventDescriptionView({ html }: { html: string }) {
  const safe = useMemo(() => sanitizeDescription(html), [html]);
  return <div className="eh-rich-text" dangerouslySetInnerHTML={{ __html: safe }} />;
}
